export default __webpack_public_path__ + "static/media/CondensingCoils.22831562.svg";